import { FaCircleDollarToSlot } from "react-icons/fa6";
import IventoryCard from "../../common/helpers/inventory-card";
import { useNavigate } from "react-router-dom";
import { HiUserGroup } from "react-icons/hi2";
import { FaCarCrash, FaLaptopCode, FaMotorcycle, FaPeopleArrows } from "react-icons/fa";
import { BsFillPersonXFill, BsRocketTakeoffFill } from "react-icons/bs";
import { AiFillAlert, AiFillTool } from "react-icons/ai";
import { MdCurrencyExchange, MdOutlineApartment, MdOutlineCancelPresentation } from "react-icons/md";
import { TbCarCrane } from "react-icons/tb";
import { GrDocumentMissing } from "react-icons/gr";
import { GoAlertFill } from "react-icons/go";

export function CardsTutorial() {
  const navigate = useNavigate();

  // Mapeia os cards para seus respectivos links (null indica que não há tutorial disponível)
  const tutorialLinks = {
    'comercial': 'https://drive.google.com/drive/folders/1zN5B1P6WsFPfOcb3-d5_eu8um8pBs2ya',
    'Embaixador': 'https://drive.google.com/drive/folders/1yjsfy61rQf2M-h2NymK85yWs-dUj-nHf',
    'marketing': 'https://drive.google.com/drive/folders/1sy17LLaBLBvY8pRBSFaRUxi5SMX0ZfAe',
    'Problemas com GOV': 'https://drive.google.com/drive/folders/17dKXZLhFdZTakAQYKwgq5js5h2CC-5UZ',
    'CadastroGov': 'https://drive.google.com/drive/folders/11i3a9IKAyJoTUWeNH10dmUviZ1UOYRd0',
    'cancelamento': 'https://drive.google.com/drive/folders/10-AVDuLkCqZ6QCDnUx7UjupxuHFaiYRq',
    'Tech': 'https://drive.google.com/drive/folders/1zA_6EueGK9kTy9LMH3Q6rBF-21fdxUAI',
    'estoque': 'https://drive.google.com/drive/folders/1doJIauLbr_mv4EbIJaku3P_nDy5Kt7FU',
    'manutencao': 'https://drive.google.com/drive/folders/1pNiogxgTJarIJ-0z2LubKHyhTjMcdwJ1',
    'sinistro': 'https://drive.google.com/drive/folders/1UHHZCshULfe6ladKSVRTuFiCnRubGOWu',
    'parcerias': 'https://drive.google.com/drive/folders/1SPDSNcz_TWS8YJYbZcm1y6L8EKvuvclw',
    'suporte-rua': 'https://drive.google.com/drive/folders/1Lb5Pc6IUu7-6WCP3Jw0SPxrWyNcR2E3P',
    'recolhimento': 'https://drive.google.com/drive/folders/1AffV-vz40653klueYaFRVc0H9lxD4wFG',
    'financeiro': 'https://drive.google.com/drive/folders/1B4V38pSDobKU6nxQrS4dPh3ckoJ4U40k',
    'renegociacao': 'https://drive.google.com/drive/folders/19M74VTHBmoN3sfvgpO-fcsjVbMA6ELoO',
    'preparacao': 'https://drive.google.com/drive/folders/1Wi39ylbWSYlPlFrppHqFW4AdZ8C5tqQh',
    'finalizacao-contrato': 'https://drive.google.com/drive/folders/1DfVHxoAFlBTI0APLAKuAoyU0MAao1yDH',
    // Adicione outros links conforme se tornarem disponíveis
  };

  // Função para gerenciar links de tutoriais
  const handleTutorialClick = (type: string, driveLink: string | null = null) => {
    if (driveLink) {
      window.open(driveLink, '_blank');
    } else if (type) {
      navigate(`/tutoriais/${type}`);
    }
  }

  // Função para renderizar um card baseado em sua disponibilidade
  const renderCard = (title: string, icon: React.ReactNode, linkKey: string) => {
    const link = tutorialLinks[linkKey];

    if (link) {
      // Card com tutorial disponível
      return (
        <a onClick={() => handleTutorialClick('', link)}
          className="hover:cursor-pointer col-span-1">
          <IventoryCard
            icon={icon}
            iconSize="70px"
            title={title}
          />
        </a>
      );
    } else {
      // Card sem tutorial disponível - com tooltip
      return (
        <div className="col-span-1 opacity-70 cursor-not-allowed">
          <IventoryCard
            icon={icon}
            iconSize="70px"
            title={title}
            divClassName="border border-dashed border-gray-400"
            tooltip="Tutorial ainda não disponível" // Usando a nova propriedade tooltip
          />
        </div>
      );
    }
  };

  return (
    <div className="col-span-4 grid grid-cols-1 md:grid-cols-1 xl:grid-cols-4 gap-3 mt-2 p-4">
      {renderCard("Comercial", <HiUserGroup />, "comercial")}
      {renderCard("Embaixador", <FaPeopleArrows />, "Embaixador")}
      {renderCard("Tech", <FaLaptopCode />, "Tech")}
      {renderCard("Marketing", <BsRocketTakeoffFill />, "marketing")}
      {renderCard("Problemas com GOV", <GoAlertFill />, "Problemas com GOV")}
      {renderCard("Cadastrar cliente no Gov", <AiFillAlert />, "CadastroGov")}
      {renderCard("Cancelamento", <MdOutlineCancelPresentation />, "cancelamento")}
      {renderCard("Manutenção", <AiFillTool />, "manutencao")}
      {renderCard("Sinistro", <FaCarCrash />, "sinistro")}
      {renderCard("Parcerias", <MdOutlineApartment />, "parcerias")}
      {renderCard("Suporte de Rua", <TbCarCrane />, "suporte-rua")}
      {renderCard("Recolhimento", <BsFillPersonXFill />, "recolhimento")}
      {renderCard("Financeiro", <FaCircleDollarToSlot />, "financeiro")}
      {renderCard("Renegociação", <MdCurrencyExchange />, "renegociacao")}
      {renderCard("Preparação", <FaMotorcycle />, "preparacao")}
      {renderCard("Finalização de contrato", <GrDocumentMissing />, "finalizacao-contrato")}
    </div>
  )
}